<template>
  <div>
    <div class="nav_container">
      <div class="navbar_1 py-1 bg-light">
        <div class="container">
          <nav class="navbar navbar-expand-md navbar-light">
            <a class="navbar-brand " href="/">
              <img src="../../assets/index/logo.png" height="40" alt="">
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" ref="navbarSupportedContent" id="navbarSupportedContent">
              <ul class="navbar-nav mr-auto">
                <template v-for="item of navListLocal">
                  <li @click="navItemClickLocal(item)" :key="item.key"
                      :class="{'active_item':activeClassFlag(item)}" class="nav-item">
                    <a href="javascript:void(0);" class="nav-link" >{{ item.title }}</a>
                  </li>
                </template>
              </ul>
<!--              <div class="form-inline  my-2 my-lg-0 d-none d-xl-block">-->
<!--                <img src="../../assets/nav/qrcode.jpg" width="50"/>-->
<!--                <span class="pl-1 ">微信小程序</span>-->
<!--                &lt;!&ndash;                <input class="form-control form-control-sm mr-2 w-75" type="search" placeholder="请输入搜索内容"&ndash;&gt;-->
<!--&lt;!&ndash;                       aria-label="Search">&ndash;&gt;-->
<!--&lt;!&ndash;                <button class="btn btn-outline-primary my-2 my-sm-0 btn-sm" type="submit">搜索</button>&ndash;&gt;-->
<!--              </div>-->
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {getActionSimple} from "@/utils/manager";
import {InfoMixins} from "@/mixins/InfoMixins";
import {PortalMenuApi} from "@/api/PortalMenuApi";

export default {
  name: 'IndexNav',
  mixins: [InfoMixins],
  data() {
    return {
      navActiveIndex: 0,
      navActiveKey: null,
      navList: [],
      navListLocal: [
        {key: 0, title: '首页', url: '/index'},
        {key: 1, title: '协会介绍', url: '/introduce'},
        {key: 2, title: '党建新闻', url: '/dangNews'},
        {key: 3, title: '政策法规', url: '/policyNews'},
        {key: 4, title: '通知公告', url: '/noticeNews'},
        {key: 5, title: '行业信息', url: '/industry'},
      ],
    }
  },
  async created() {
  },
  methods: {
    navItemClickLocal(item){
      this.navActiveKey = item.key
      let toLink = item.url
      if (toLink) {
        let {fullPath, redirectedFrom} = this.$route

        //处理一些特殊情况
        const eqArray = ["/", "index"]
        if (toLink !== fullPath && eqArray.includes(toLink) && eqArray.includes(fullPath)) {
          return
        }
        // console.log(this.$route, "当前路由->", this.$route.fullPath, "跳转路由->", toLink)
        if (toLink && fullPath !== toLink && toLink !== redirectedFrom) {
          this.$router.push(toLink);
        }
      }

      this.$refs.navbarSupportedContent.classList.remove('show')
    },
  },
  computed: {
    //是否激活样式
    activeClassFlag() {
      return item => {
        //当前激活是自己,所以展示
        return this.navActiveKey === item.key;

      }
    }
  },
  watch: {
    '$route.path':{
      immediate: true,
      handler(n){
        {
          for (let item of this.navListLocal) {
            if (item.url === n) {
              this.navActiveKey = item.key
            }
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../scss/public";

::v-deep .navbar-nav {
  //font-size: 1.125rem;
}

.nav_container {
  .container {
    nav {
      .nav-item {
        //font-weight: bold;
        //margin-left: 2rem;
        //font-size: 20px;
        font-size: 18px;
        font-weight: bold;
      }

      .nav-item, .navbar-brand {
        margin-left: 1.5rem;

        .nav-link {
          &:focus {
            color: $nav-font-color1;
          }

          &:hover {
            color: $color1;
          }
        }
      }

      .dropdown-menu {
        display: none;
      }

      //只在屏幕宽度大于1200px时，才有hover事件
      @media screen and (min-width: 1200px) {
        .dropdown:hover {
          .dropdown-menu {
            display: block;
          }
        }
      }

      a.nav-link, a.navbar-brand {
        color: $nav-font-color1;
      }

      .active_item {
        & > a {
          color: $color1 !important;
        }

        color: $color1 !important; //为了处理其他场景
      }

      .dropdown-menu {
        margin: 0;
        padding: 0;

        .dropdown-item {
          padding: 0.5rem 1.5rem;
          color: $nav-font-color1;
          font-weight: bold;
          //font-size: 18px;

          &:hover {
            color: $color1;
          }

          &:active {
            background-color: #e9ecef;
            color: $color1;
          }
        }
      }
    }
  }

  .bg-light {
    //background-color: $color3 !important;
  }
}

.animate__animated.animate__fadeInUp {
  --animate-duration: 0.2s;
}
</style>
